import * as moment from 'moment-timezone';
import { ChallengeService } from 'app/shared/services/challenge.service';
import { Subject } from 'rxjs';
import { UserService } from 'app/shared/services/user.service';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
/**
 * Statistics section for challenges, containing information about challenge.
 * Challenge is either displayed as future, running or past. Past challenge is displayed for 14 days after challenge concludes.
 */
var ChallengeStatisticsComponent = (function () {
    function ChallengeStatisticsComponent(challengeService, userService, route, snackBar, translate) {
        this.challengeService = challengeService;
        this.userService = userService;
        this.route = route;
        this.snackBar = snackBar;
        this.translate = translate;
        this.ngUnsubscribe = new Subject();
    }
    ChallengeStatisticsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.challengeService.displayedChallenge.takeUntil(this.ngUnsubscribe).subscribe(function (challenge) {
            if (challenge) {
                _this.displayedChallenge = challenge;
                _this.isFutureChallenge = moment(challenge.start).isAfter(moment());
                _this.setDisplayedTimeframe();
            }
            else {
                _this.displayedChallenge = null;
                _this.isFutureChallenge = false;
            }
            if (_this.requestedChallengeID && (!challenge || challenge._id !== _this.requestedChallengeID)) {
                _this.snackBar.open(_this.translate.instant('CHALLENGE.error.challengeIsPast'), null, {
                    verticalPosition: 'top',
                    duration: 4000,
                    panelClass: ['b2a-error', 'top'],
                });
            }
        });
        this.route.queryParams.takeUntil(this.ngUnsubscribe).subscribe(function (params) {
            if (params.challengeID) {
                _this.requestedChallengeID = params.challengeID;
            }
        });
        this.userService.currentUser.takeUntil(this.ngUnsubscribe).subscribe(function (user) {
            if (user) {
                _this.currentUser = user;
                _this.setDisplayedTimeframe();
            }
        });
    };
    ChallengeStatisticsComponent.prototype.setDisplayedTimeframe = function () {
        if (!this.displayedChallenge || !this.currentUser) {
            return;
        }
        var language = this.currentUser.language;
        moment.locale('de');
        if (language === 'en') {
            moment.locale('en');
        }
        this.displayedTimeframe =
            moment(this.displayedChallenge.start).tz(this.currentUser.timeZone).format('L') +
                ' - ' +
                moment(this.displayedChallenge.end).tz(this.currentUser.timeZone).format('L');
    };
    /**
     * On destroy cancel active subscriptions
     */
    ChallengeStatisticsComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return ChallengeStatisticsComponent;
}());
export { ChallengeStatisticsComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/challenge-statistics/challenge-statistics.component.ts.pre-build-optimizer.js